<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        layout="inline"
        @submit="handleSearch"
        :autoFormCreate="
          (form) => {
            this.searchForm = form;
          }
        "
      >
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="搜索商品" fieldDecoratorId="name">
              <a-input placeholder="名称" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-divider type="vertical" />
              <a-button @click="$refs.file.click()">
                <a-icon type="upload" />一键导入
              </a-button>
              <a-divider type="vertical" />
              <a-button @click="downloadTemplate">
                <a-icon />下载模版
              </a-button>
              <input
                type="file"
                ref="file"
                style="display: none"
                @change="upload"
                name="file"
              />
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="cover" slot-scope="text, record">
        <span class="pic" @click="previewImage(record)"
          ><img :src="text"
        /></span>
      </template>
      <template slot="quantity" slot-scope="text, record">
        <input v-model.number="record.quantity" style="width: 80px" />
      </template>
      <template slot="unit_price" slot-scope="text, record">
        <input v-model.number="record.unit_price" style="width: 80px" />
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="handleOrder(record)">收藏</a>
        </div>
      </template>
    </s-table>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      size="middle"
      @cancel="previewVisible = false"
      :showUploadList="false"
    >
      <img alt="example" style="width: 100%" :src="previewImages" />
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { chooseOption } from "@/api/purchase";
import { getGoodsList } from "@/api/goods";
import { getBranchList } from "@/api/branch";
import { encodeJsonToQuery } from "@/utils/util";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  name: "OptionList",
  components: {
    STable,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      actionUrl:
        "/api/admin/temporary/upload" +
        encodeJsonToQuery({ token: this.$ls.get(ACCESS_TOKEN) }),
      suppliers: [],
      form: null, // 查询参数
      previewVisible: false,
      loading: false,
      searchForm: null,
      queryParam: {}, // 表头
      row: {},
      branches: [],
      branch_id: 0,
      previewImages: "",
      columns: [
        {
          title: "图片",
          dataIndex: "pic_url",
          scopedSlots: { customRender: "cover" },
        },
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "sku",
          dataIndex: "sku",
        },
        {
          title: "兑换规则",
          dataIndex: "exchange_price",
        },
        {
          title: "供应商",
          dataIndex: "supplier_name",
        },
        {
          title: "总销量",
          dataIndex: "total_sales",
        },
        {
          title: "采购总量",
          dataIndex: "total_purchases",
        },
        {
          title: "平均采购价格",
          dataIndex: "average_price",
        },
        {
          title: "下单数量",
          dataIndex: "quantity",
          scopedSlots: { customRender: "quantity" },
        },

        {
          title: "单价",
          dataIndex: "unit_price",
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getGoodsList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
    };
  },
  created() {
    this.getBranchList();
  },
  computed: {
    hasSelected() {
      return this.selectedRows.length > 0;
    },
  },
  methods: {
    downloadTemplate: function () {
      window.open("https://static.bianfuyule.com/temporary.xlsx", "_self");
    },
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        name: this.searchForm.getFieldValue("name"),
      };
      this.$refs.table.refresh();
    },
    handleOrder(row) {
      const branch_id = this.searchForm.getFieldValue("branch_id");
      if (!branch_id) {
        this.$message.error("请选择下单门店");
        return;
      }
      const params = {
        goods_id: row.id,
        quantity: row.quantity,
        unit_price: row.unit_price,
        branch_id: this.searchForm.getFieldValue("branch_id"),
      };
      chooseOption(params).then((res) => {
        this.$message.success("订单已生成");
        this.row = {};
        this.$refs.table.refresh();
      });
    },
    handleExport(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} 上传成功`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    upload(e) {
      let files = e.target.files;
      if (files.length > 0) {
        let data = new FormData();
        data.append("file", files[0]);
        fetch("/api/admin/temporary/upload", {
          method: "POST",
          body: data,
          headers: {
            Authorization: `Bearer ${this.$ls.get(ACCESS_TOKEN)}`,
          },
        }).then((res) => {
          if (res.status == 200) {
            const a = document.createElement("a");
            let filename = res.headers
              .get("content-disposition")
              .replace("attachment; filename=", "");
            res.blob().then((blob) => {
              a.href = URL.createObjectURL(blob);
              a.download = decodeURIComponent(filename);
              a.click();
              URL.revokeObjectURL(a.href);
            });
          } else if (res.status == 401) {
            res.json().then((data) => {
              //token过期或者token错误会进入此处，需要将登录状态清除并要求重新登录
              this.$message.error(`上传失败，${data.msg}`);
            });
          }
        });
      }
    },
    previewImage(record) {
      this.previewImages = record.pic_url;
      this.previewVisible = true;
    },
  },
};
</script>
<style scoped>
.pic {
  width: 60px;
  height: 60px;
}
.pic > img {
  width: 60px;
  height: 60px;
  display: block;
}
</style>
